import { createPaginatedSlice } from "../../helpers/reduxHelper";

const sharedFilesPage = createPaginatedSlice('sharedFilesPage');

export const sharedFilesPageActions = sharedFilesPage.actions
export const sharedFilesPageSelector = state => state.sharedFilesPage;
export const sharedFilesPageReducer = sharedFilesPage.reducer;
export default sharedFilesPageReducer

export const sharedFilesPageSelectors = sharedFilesPage.LF.selectors